/* tslint:disable */

declare var Object: any;
export interface SunfishAuthenticatorServiceInterface {
  "id"?: number;
}

export class SunfishAuthenticatorService implements SunfishAuthenticatorServiceInterface {
  "id": number;
  constructor(data?: SunfishAuthenticatorServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SunfishAuthenticatorService`.
   */
  public static getModelName() {
    return "SunfishAuthenticatorService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SunfishAuthenticatorService for dynamic purposes.
  **/
  public static factory(data: SunfishAuthenticatorServiceInterface): SunfishAuthenticatorService{
    return new SunfishAuthenticatorService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SunfishAuthenticatorService',
      plural: 'SunfishAuthenticatorServices',
      path: 'SunfishAuthenticatorServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SunfishAuthenticatorService.ts